export default {

  /**
   * Check if a string is blank, null or undefined
   *
   * @param str string target
   */
  isBlank(str) {
    return !str || /^\s*$/.test(srt);
  },

  getPaginationData(model){
    return {
      rows: model.total,
      currentPage: model.current_page,
      paginaActual: model.current_page,
      perPage: model.per_page,
      totalPaginas: model.last_page,
    }
  },

  paginationModel() {
    return {
      paginaActual: 1,
      rows: 0,
      totalPaginas: 1,
      currentPage: 1,
      perPage: 25,
    }
  },


  formatDataSelect({ label, value }) {
    return {
      label: label,
      value: value
    }
  },




}
